import dayjs from 'dayjs';

const removeHtmlTags = /<\/?[a-z][\s\S]*?>/gi;

export const getKeycloakRealm = window.location.pathname.split('/')[1];
/**
 * Uklanja HTML tagove iz stringa koristeći regex.
 * @param input - String koji može sadržavati HTML tagove.
 * @returns String bez HTML tagova.
 */
export const stripHtmlTags = (input: string): string => {
  return input.replace(removeHtmlTags, '');
}
  /**
 * Sets the hours, minutes, and seconds of a Day.js object using total seconds.
 * @param totalSeconds - Total seconds to set on the Day.js object.
 * @returns A Day.js object with the specified hours, minutes, and seconds.
 */
  export const setTimeWithSeconds = (totalSeconds: number | undefined): dayjs.Dayjs => {
    if (totalSeconds === undefined) {
      return dayjs();
    }
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    // Create a Day.js object and set hours, minutes, and seconds
    let date = dayjs().hour(hours).minute(minutes).second(seconds);

    return date;
  }
